module.exports = __webpack_public_path__ + "img/icon-const-norm-bg-1.9de4b19f.png";